'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _rocketjump = require('../../rocketjump');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var makeMeta = function makeMeta(toMeta, args) {
  return toMeta.reduce(function (meta, metaName, i) {
    if (!metaName || args.length <= i) {
      return meta;
    }

    return _extends({}, meta, _defineProperty({}, metaName, args[i]));
  }, {});
};

exports.default = function () {
  for (var _len = arguments.length, toMeta = Array(_len), _key = 0; _key < _len; _key++) {
    toMeta[_key] = arguments[_key];
  }

  return (0, _rocketjump.rj)({
    proxyActions: {
      load: function load(_ref) {
        var _load = _ref.load;
        return function () {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          var meta = toMeta ? makeMeta(toMeta, args) : {};
          return _load(args, meta);
        };
      }
    }
  });
};